import { isStandaloneDisplay } from "../../pwa/pwaUtils";

export function detectDeviceType() {
  if (typeof window === "undefined") return "unknown";
  const w = window.innerWidth || 0;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export function baseDeviceParams() {
  const isOffline =
    typeof navigator !== "undefined" ? navigator.onLine === false : false;
  let isPwa = false;
  try {
    isPwa = isStandaloneDisplay();
  } catch {
    isPwa = false;
  }
  return {
    device_type: detectDeviceType(),
    is_pwa: isPwa,
    is_offline: isOffline,
  };
}
